import type { ConsoleTab } from "../components/ConsoleTabs";
import { CONSOLE_DOMAIN_TABS } from "../components/ConsoleTabs";

const VALID_CONSOLE_TABS = new Set<string>(
  CONSOLE_DOMAIN_TABS.map((t) => t.value),
);

/**
 * Return the top-level domain segment for display/filtering.
 * `cortex.session` → `cortex`, `notification.push` → `notification`.
 */
export function getDomainRoot(domain: string): string {
  return domain.split(".")[0] ?? domain;
}

/**
 * Normalise a raw Mycelium/Cortex domain to a known console tab value.
 * Returns `undefined` when the root does not match a tab.
 */
export function toConsoleTab(domain: string): ConsoleTab | undefined {
  const root = getDomainRoot(domain);
  if (VALID_CONSOLE_TABS.has(root)) {
    return root as ConsoleTab;
  }
  return undefined;
}
